import React from "react";
import { useDesigner } from "./useDesigner";
import { ElementState } from "./useElementContext";
import { useChannel } from "../core/hooks/useChannel";
import { DesignerMessages } from "./types";
import { newID } from "../core/utils/unique";

export function getElementID(id: number) {
	return "content-element-" + id;
}

export function useContentState(elementContext: ElementState, handler: (msg: any) => void) {
	const designer = useDesigner();

	if (!elementContext.def.id) alert("Must have id specified");

	const [focused, setFocused] = React.useState((designer.focus === elementContext.def));
	const [token, refresh] = React.useState("");

	let classes = 
		(focused ? "focused" : "")
	;

	const elementID = getElementID(elementContext.def.id!);

	useChannel(designer.channel + "/" + elementContext.def.id!, 
		React.useCallback((msg: any) => {
			// some default handling
			if (msg.type === DesignerMessages.GET_REF) {
				msg.ref = elementContext.def;

			} else if (msg.type === DesignerMessages.GET_CONTEXT) {
				msg.context = elementContext;

			} else if (msg.type === DesignerMessages.FOCUS) {
				setFocused(true);
				document.getElementById(elementID)?.focus();

			} else if (msg.type === DesignerMessages.BLUR) {
				setFocused(false);

			} else if (msg.type === DesignerMessages.REFRESH) {
				refresh(newID());				

			} else {
				handler(msg);

			}
		}, [handler, elementContext]),
	);

	return {
		focused,
		classes,
		elementID,
		refresh,
		token,
	}
}